module.exports = __webpack_public_path__ + "static/media/logo.548f2aac.svg";